import type { ReactNode } from 'react';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  /** Action principale unique (ex. « Créer une visio »). */
  action?: ReactNode;
  headingLevel?: 2 | 3;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  headingLevel = 2,
}: EmptyStateProps) {
  const Heading = headingLevel === 2 ? 'h2' : 'h3';
  return (
    <div className="av-empty-state">
      {icon ? (
        <div className="av-empty-state__icon" aria-hidden="true">
          <span className="av-icon">{icon}</span>
        </div>
      ) : null}
      <Heading className="av-empty-state__title">{title}</Heading>
      {description ? <p className="av-empty-state__description">{description}</p> : null}
      {action ? <div className="av-empty-state__action">{action}</div> : null}
    </div>
  );
}
